import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

class ProductSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title} style={{ color: "#4BB64B" }}>Product & Services</h2>
            <h4 className={classes.description}>
            Sandton Consulting is a service company who helps you to unleash your company potentials based on your current resources to gain the most benefit of your business under desired calculated risks potentials. Our experts and partners are professional with years of experience who can tailored suitable solutions to organizations of any size and any context.
            </h4>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/HomePage/Sections/ProductSection.jsx